export default {
  title: 'Tablet lojalnościowy',
  headers: {
    customer_frequency: 'Częstotliwość odwiedzin klientów',
  },
};
